var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13239 2H11.25V6.25H2.45001L4.4174 2.97101C4.77885 2.3686 5.42986 2 6.13239 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2V6.25H21.55L19.5826 2.97101C19.2212 2.3686 18.5701 2 17.8676 2H12.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75H19.75L2.21434 20.9017C2.07724 20.6308 2 20.3244 2 20V7.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38043 21.9022C3.5755 21.9657 3.78374 22 4 22H20C21.1046 22 22 21.1046 22 20V7.9375L3.38043 21.9022Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox9);
export default __webpack_public_path__ + "static/media/box-9.183313c225caf89ac9388eb4e40c1de2.svg";
export { ForwardRef as ReactComponent };